import React from 'react'

interface BackdropProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Backdrop = (props: BackdropProps) => {
    const styling = 'bg-shade-900/25 absolute top-0 left-0 right-0 bottom-0 -z-10'
    return <div {...props} className={`${styling} ${props.className}`} />
}
